<template>
    <div>
        <BankAccountForm
            :mode="PAYOUT_METHOD_MODE_ADD"
            :payout-account="payoutAccount"
            :payout-method="payoutMethod"
            @success="handleSuccess"
            @back="handleBack"
        />
    </div>
</template>

<script>
    import BankAccountForm from './BankAccountForm';
    import { PAYOUT_METHOD_MODE_ADD } from '../../../../../app-v2/constants/payouts';

    export default {
        name: 'AddBankAccount',

        props: {
            payoutAccount: {
                type: Object,
                default: null
            },
            payoutMethod: {
                type: Object,
                default: null
            }
        },

        components: {
            BankAccountForm
        },

        setup(props, context) {
            const handleSuccess = () => {
                context.emit('success');
            };

            const handleBack = () => {
                context.emit('back');
            };

            return {
                PAYOUT_METHOD_MODE_ADD,
                handleSuccess,
                handleBack
            };
        }
    };
</script>
